module.exports = __webpack_public_path__ + "img/girl3.6d524943.jpg";